// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-layer[data-v-9ae79978]{position:absolute;top:50px;right:0;min-width:90vw;background-color:#fff;padding:1rem;border-radius:1rem;box-shadow:0 2px 48px 20px rgba(0,0,0,.06);z-index:1}.cart-layer .list-item[data-v-9ae79978]{border-radius:0;padding:5px;cursor:default;margin-bottom:5px;border-bottom:1px dashed grey;box-shadow:none}.cart-layer .li-c[data-v-9ae79978]{min-height:0}.cart-layer .style4[data-v-9ae79978]{width:100%;padding:5px}", ""]);
// Exports
module.exports = exports;
